<template>
  <div>
    <div class="ts-flex ts-items-center ts-justify-between ts-border-b ts-border-gray-500 ts-py-1">
      <label class="ts-w-full ts-uppercase" style="margin-bottom: 0;">
        {{ $t('school.academic.setup.program.grade.subjectGroup') }}
      </label>
      <ts-button color="primary" size="sm" @click="addNewRow">
        <i class="fas fa-plus mr-2"></i>{{ $t('add_new') }}
      </ts-button>
    </div>

    <div>
      <table id="table-details">
        <thead class="ts-bg-gray-200">
          <tr>
            <th style="width: 30%">{{ $t('school.academic.setup.program.grade.groupName') }}</th>
            <th style="width: 65%">{{ $t('school.academic.setup.program.grade.subjectGroup') }}</th>
            <th style="width: 5%; text-align: center">{{ $t('actions') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="model.grade_subject_group.length === 0">
            <td colspan="3" class="text-center text-muted">
              <i>{{ $t('noData') }}</i>
            </td>
          </tr>
          <tr v-for="(item, index) in model.grade_subject_group" :key="index">
            <td>
              <input type="text" v-model="item.item_group" class="form-control form-control-sm" />
              <div class="validate" v-if="errors.has('grade_subject_group.' + index + '.item_group')">
                {{
                  errors.first('grade_subject_group.' + index + '.item_group')
                }}
              </div>
            </td>
            <td>
              <a-select v-model="item.subject_id_list" mode="multiple" :maxTagCount="2" style="width: 100%"
                placeholder="Select subjects" showSearch :filterOption="(input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                  ">
                <a-select-option v-for="subject in availableSubjects" :key="subject.subject_id"
                  :value="subject.subject_id">
                  {{ subject.subject_name_foreign }}
                  {{ subject.subject_code ? '| ' + subject.subject_code : '' }}
                </a-select-option>
              </a-select>
              <div class="validate" v-if="errors.has('grade_subject_group.' + index + '.subject_id_list')">
                {{
                  errors.first('grade_subject_group.' + index + '.subject_id_list')
                }}
              </div>
            </td>
            <td class="text-center">
              <template>
                <a href="#" v-tooltip="$t('delete')" class="text-danger" @click.prevent="deleteRow(index)">
                  <i class="fas fa-trash"></i>
                </a>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'groupSubject',
  props: ['value', 'validate', 'subjects'],
  data() {
    return {
      errors: new Errors(),
      model: {},
    }
  },
  computed: {
    availableSubjects() {
      // Get subjects from parent model that are already checked
      if (!this.model.subject_list || this.model.subject_list.length === 0) {
        return []
      }
      return this.subjects.filter(subject =>
        this.model.subject_list.includes(subject.subject_id)
      )
    }
  },
  methods: {
    addNewRow() {
      this.model.grade_subject_group.push({
        grade_subject_group_id: null,
        grade_id: this.model.grade_id,
        item_group: '',
        subject_id_list: [],
      })
    },
    deleteRow(index) {
      this.model.grade_subject_group.splice(index, 1)
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(val) {
        this.model = val
      },
    },
    model: {
      deep: true,
      handler(val) {
        this.$emit('value', val)
      },
    },
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  },
}
</script>

<style scoped>
#table-details>thead>tr>th {
  padding: 5px 4px;
  background: #f2f3f4;
}

#table-details>tbody>tr>td {
  padding: 5px 4px;
  border: none !important;
  font-size: 12px !important;
}

.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
}

.btn.btn-sm {
  line-height: 0;
}
</style>
